import React, { useEffect, useState } from "react";
import {
  FiLock, FiScissors, FiPlus,
} from "react-icons/fi";
import { FormattedMessage, useIntl } from "react-intl";
import Sidebar, { SidebarItem } from "../../components/Sidebar/Sidebar";
import ProfileForm from "./ProfileForm";
import styles from "./NewProfile.module.scss";
import { useSelector } from "react-redux";
import Spinner from "../../components/Spinner";
import { useDispatch } from "react-redux";
import { getPatternsByUserId } from "../../actions/patternActions";
import PatternGrid from "../../components/Patterns/PatternGrid";
import ManagePattern from "../Patterns/ManagePattern";
import { BiStar } from "react-icons/bi";
import { useLocation, useNavigate } from "react-router-dom";
import { TbHistory } from "react-icons/tb";

const NewProfile = () => {
  const user = useSelector((state: any) => state.auth.user);
  const profilePhoto = useSelector((state: any) => state.profile?.profile?.photo)
  // check if the profile update also contains the account upgrade to creator
  const isCreatorFromProfileUpdate = useSelector((state: any) => state.profile?.profile?.user?.role?.includes("creator"));

  const [activeTab, setActiveTab] = useState("account");
  const dispatch = useDispatch();
  const id = user?._id;
  const patterns = useSelector((state: any) => state.patternList.patterns);
  const navigate = useNavigate();
  const location = useLocation();
  const intl = useIntl();

  useEffect(() => {
    if (user) {
      dispatch(getPatternsByUserId(id));
    }

  }, [user, id, dispatch]);

  if (!user) {
    return <Spinner />;
  }

  const NAV_ITEMS: SidebarItem[] =
    isCreatorFromProfileUpdate || user?.role?.includes("creator")
      ? [
        { id: "account", label: user?.user?.name || "", icon: <FiLock size={16} /> },
        {
          id: "patterns",
          label: intl.formatMessage({ id: "profile.nav.myPatterns", defaultMessage: "My patterns" }),
          icon: <FiScissors size={16} />,
        },
        {
          id: "add",
          label: intl.formatMessage({ id: "profile.nav.addPattern", defaultMessage: "Add new pattern" }),
          icon: <FiPlus size={16} />,
        },
        {
          id: "portal",
          label: intl.formatMessage({ id: "profile.nav.creatorPortal", defaultMessage: "Creator portal" }),
          icon: <BiStar size={16} />,
        },
        {
          id: "history",
          label: intl.formatMessage({ id: "profile.nav.purchaseHistory", defaultMessage: "Purchase history" }),
          icon: <TbHistory size={16} />,
        },
      ]
      : [
        { id: "account", label: user?.name || "", icon: <FiLock size={16} /> },
        {
          id: "history",
          label: intl.formatMessage({ id: "profile.nav.purchaseHistory", defaultMessage: "Purchase history" }),
          icon: <TbHistory size={16} />,
        },
        // { id: "messages", label: "Wiadomości", icon: <FiMail size={16} /> },
        // { id: "favorites", label: "Ulubione", icon: <FiHeart size={16} /> },
      ];

  const propsObject =
    isCreatorFromProfileUpdate || user?.role?.includes("creator")
      ? {
        name: user?.user?.name,
        email: user?.email,
        bio: user?.user?.bio,
        handle: user?.handle,
        country: user?.country,
        website: user?.website,
        instagram: user?.social?.instagram,
        facebook: user?.social?.facebook,
        youtube: user?.social?.youtube,
        isCreator: true
      }
      : {
        name: user?.name,
        email: user?.email,
        bio: user?.user?.bio,
        country: user?.country,
        website: user?.website,
        isCreator: false
      };

  const renderContent = () => {
    switch (activeTab) {
      case "account":
        return <ProfileForm {...propsObject} />;
      case "patterns":
        return <PatternGrid patterns={patterns} variant="owner" />;
      case "sales":
        return <div>Sales Dashboard</div>;
      case "add":
        return <ManagePattern goback={false} />;
      case "messages":
        return <div>Messages</div>;
      case "favorites":
        return <div>Favorites</div>;
      case "portal":
        navigate("/creator/dashboard", {
          state: {
            from: location.pathname,
          },
        });
        return null;
      case "history":
        navigate('/purchase-history')
        return null;
      default:
        return <ProfileForm {...propsObject} />;
    }
  };

  return (
    <div className={styles.page}>
      {/* ── Header ── */}
      <div className={styles.header}>
        <h1 className={styles.heading}>
          <FormattedMessage id="profile.page.title" defaultMessage="My profile" />
        </h1>
        <p className={styles.subheading}>
          <FormattedMessage
            id="profile.page.subtitle"
            defaultMessage="Sharing information about you helps visitors get to know your style!"
          />
        </p>
      </div>

      {/* ── Content ── */}
      <div className={styles.content}>
        <Sidebar
          items={NAV_ITEMS}
          activeId={activeTab}
          onItemClick={setActiveTab}
          photoUrl={profilePhoto || user.photo}
        />

        <div className={styles.main}>
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default NewProfile;